<template>
     <div class="container-fluid">
         <div class="row">
            <div class="col-lg-8 col-md-12">
               <div class="card">
                  <div class="card-header d-flex justify-content-between">
                     <div class="header-title">
                        <h4 class="card-title">Add New Game</h4>
                     </div>
                  </div>
                  <div class="card-body">
                     <form>
                        <div class="form-group mb-3 pb-1">
                           <label for="code">Game Code:</label>
                           <b-form-input type="text" id="code" placeholder="Game Code" :class="`form-control ${$v.gameForm.code.$error ? 'is-invalid' : ''}`"
                              v-model="gameForm.code" @input="$v.gameForm.code.$touch()" @blur="$v.gameForm.code.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>
                           
                        <div class="form-group mb-3 pb-1">
                           <label for="name">Game Name:</label>
                           <b-form-input type="text" id="name" placeholder="Game Name" :class="`form-control ${$v.gameForm.name.$error ? 'is-invalid' : ''}`"
                              v-model="gameForm.name" @input="$v.gameForm.name.$touch()" @blur="$v.gameForm.name.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="name">Game Name (CN):</label>
                           <b-form-input type="text" id="nameCN" placeholder="游戏中文名" :class="`form-control`"
                              v-model="gameForm.nameCN">
                           </b-form-input>
                        </div>

                         <!-- <div class="form-group mb-3 pb-1">
                           <label for="image"><bold class="asterik">*</bold>Image</label>
                           <input type="file" name="image" style="width: 50%;" class="form-control-file" id="picture" :class="`form-control ${$v.gameForm.image.$error ? 'is-invalid' : ''}`"  @change="onFileChange">
                        </div>
                        <div class="invalid-feedback"><small>Required field</small></div>

                        <img v-bind:src="imagePreview" width="50%" style="margin-bottom: 35px;" v-show="showPreview"/>
                        <br> -->

                        <div class="form-group mb-3 pb-1" id="my-strictly-unique-vue-upload-multiple-image">
                           <label for="image">Images: </label>
                           <vue-upload-multiple-image
                              @upload-success="uploadImageSuccess"
                              @before-remove="beforeRemove"
                              @edit-image="editImage"
                              :data-images="image"
                              idUpload="myIdUpload"
                              editUpload="myIdEdit"
                              ></vue-upload-multiple-image>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="shortDesc">Short Description:</label>
                           <b-form-textarea id="shortDesc" placeholder="Short Desc." :class="`form-control ${$v.gameForm.shortDesc.$error ? 'is-invalid' : ''}`"
                              v-model="gameForm.shortDesc" @input="$v.gameForm.shortDesc.$touch()" @blur="$v.gameForm.shortDesc.$touch()" required>
                           </b-form-textarea>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="longDesc">Long Description:</label>
                           <b-form-textarea id="longDesc" placeholder="Long Desc." size="lg" :class="`form-control ${$v.gameForm.longDesc.$error ? 'is-invalid' : ''}`"
                              v-model="gameForm.longDesc" @input="$v.gameForm.longDesc.$touch()" @blur="$v.gameForm.longDesc.$touch()" required>
                           </b-form-textarea>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <div class="mb-2 row">
                              <div class="col-10"><label for="features">Feature: </label></div>
                              <div class="col-2 d-flex flex-row-reverse align-items-center">
                                 <b-button variant="outline-primary" class="d-flex align-items-center justify-content-center" style="height: 35px!important; width: 35px!important"
                                    v-on:click="addFeature">
                                    <i class="las la-plus-circle p-0 m-0"></i>
                                 </b-button>
                              </div>
                           </div>
                           <b-input-group v-for="item, index in gameForm.feature" :key="index" class="mb-2">
                              <b-form-textarea size="sm" type="text" placeholder="Feature" v-model="gameForm.feature[index]" :value="item"></b-form-textarea>
                              <b-input-group-append>
                                 <b-button variant="outline-danger" class="d-flex align-items-center justify-content-center" v-on:click="removeFeature(index)"><i class="las la-trash"></i></b-button>
                              </b-input-group-append>
                           </b-input-group>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="line">Line / Way:</label>
                           <b-form-input type="text" id="line" placeholder="Line/ Way" :class="`form-control ${$v.gameForm.line.$error ? 'is-invalid' : ''}`"
                              v-model="gameForm.line" @input="$v.gameForm.line.$touch()" @blur="$v.gameForm.line.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="category">Category:</label>
                           <b-form-select v-model="gameForm.category" placeholder="Category" :class="`form-control ${$v.gameForm.category.$error ? 'is-invalid' : ''}`"
                              @input="$v.gameForm.category.$touch()" @blur="$v.gameForm.category.$touch()" :options="category" required ></b-form-select>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="volatility">Volatility:</label>
                           <b-form-select v-model="gameForm.volatility" placeholder="Volatility" :class="`form-control ${$v.gameForm.volatility.$error ? 'is-invalid' : ''}`"
                              @input="$v.gameForm.volatility.$touch()" @blur="$v.gameForm.volatility.$touch()" :options="volatility" required ></b-form-select>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <!-- <div class="form-group mb-3 pb-1">
                           <label for="id">Tags:</label>
                           <b-form-input type="text" id="id" placeholder="Role ID" :class="`form-control ${$v.gameForm.id.$error ? 'is-invalid' : ''}`"
                              v-model="gameForm.id" @input="$v.gameForm.id.$touch()" @blur="$v.gameForm.id.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div> -->

                        <div class="form-group mb-3 pb-1">
                           <label for="releaseDate">Release Date:</label>
                           <b-form-datepicker id="releaseDate" v-model="gameForm.releaseDate" :class="`form-control ${$v.gameForm.releaseDate.$error ? 'is-invalid' : ''}`"
                              @input="$v.gameForm.releaseDate.$touch()" @blur="$v.gameForm.releaseDate.$touch()" required></b-form-datepicker>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="rtp">RTP:</label>
                           <b-form-input type="text" id="rtp" placeholder="RTP" :class="`form-control ${$v.gameForm.rtp.$error ? 'is-invalid' : ''}`"
                              v-model="gameForm.rtp" @input="$v.gameForm.rtp.$touch()" @blur="$v.gameForm.rtp.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="platform">Platform:</label>
                           <b-form-checkbox-group id="platform" name="platform" v-model="gameForm.platform" :class="`${$v.gameForm.platform.$error ? 'is-invalid' : ''}`"
                              value-field="value" @input="$v.gameForm.platform.$touch()" @blur="$v.gameForm.platform.$touch()" required>
                              <b-form-checkbox v-for="p in platform" v-bind:key="p.value" :value="p.value"><span class="h4" v-html="p.icon"></span></b-form-checkbox>
                           </b-form-checkbox-group>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="language">Language:</label>
                           <b-form-select v-model="gameForm.language" placeholder="Language" :class="`form-control ${$v.gameForm.language.$error ? 'is-invalid' : ''}`"
                              @input="$v.gameForm.language.$touch()" @blur="$v.gameForm.language.$touch()" :options="language" required ></b-form-select>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="suppLang">Supported Language:</label>
                           <b-form-checkbox-group id="suppLang" v-model="gameForm.suppLang" :class="`${$v.gameForm.suppLang.$error ? 'is-invalid' : ''}`"
                              :options="language" value-field="value" @input="$v.gameForm.suppLang.$touch()" @blur="$v.gameForm.suppLang.$touch()" required multiple>
                           </b-form-checkbox-group>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="maxMultiplier">Max. Multiplier:</label>
                           <b-form-input type="text" id="maxMultiplier" placeholder="Max. Multiplier" :class="`form-control ${$v.gameForm.maxMultiplier.$error ? 'is-invalid' : ''}`"
                              v-model="gameForm.maxMultiplier" @input="$v.gameForm.maxMultiplier.$touch()" @blur="$v.gameForm.maxMultiplier.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="reelsRows">Reels X Rows:</label>
                           <b-form-input type="text" id="reelsRows" placeholder="Reels X Rows" :class="`form-control ${$v.gameForm.reelsRows.$error ? 'is-invalid' : ''}`"
                              v-model="gameForm.reelsRows" @input="$v.gameForm.reelsRows.$touch()" @blur="$v.gameForm.reelsRows.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>

                        <div class="form-group mb-3 pb-1">
                           <label for="gameProvider">Game Provider:</label>
                           <b-form-input type="text" id="gameProvider" placeholder="Game Prov." :class="`form-control ${$v.gameForm.gameProvider.$error ? 'is-invalid' : ''}`"
                              v-model="gameForm.gameProvider" @input="$v.gameForm.gameProvider.$touch()" @blur="$v.gameForm.gameProvider.$touch()" required>
                           </b-form-input>
                           <div class="invalid-feedback"><small>Required field</small></div>
                        </div>
                     </form>

                     <div class="col-md-12 form-group">
                        <button type="button" class="btn btn-primary float-right" v-on:click="register">Add</button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import VueUploadMultipleImage from 'vue-upload-multiple-image'

const config = require("../../../../../config");
const constants = require("../../../../constants/CommonConstants");

Vue.use(VueAxios, axios)

export default {
   name: "GameAdd",
   data() {
      return {
         gameForm: {
            code: '',
            name: '',
            nameCN: '',
            imagename: [],
            image:[],
            shortDesc: '',
            longDesc: '',
            feature: [''],
            line: '',
            category: '',
            volatility: '',
            tags: [],
            releaseDate: '',
            rtp: '',
            platform: [],
            language: 'en_US',
            suppLang: [],
            maxMultiplier: '',
            reelsRows: '',
            gameProvider: 'NEXTSPIN'
         },
         imagePreview: null,
         showPreview: false,
         category: constants.category,
         volatility: constants.volatility,
         platform: constants.platform,
         language: constants.language
      }
   },
   mixins: [validationMixin],
   validations: {
      gameForm: {
         code: { required },
         name: { required },
         image: {required},
         shortDesc: { required },
         longDesc: { required },
         feature: { required },
         line: { required },
         category: { required },
         volatility: { required },
         releaseDate: { required },
         rtp: { required },
         platform: { required },
         language: { required },
         suppLang: { required },
         maxMultiplier: { required },
         reelsRows: { required },
         gameProvider: { required }
      }
   },
   components: {
      VueUploadMultipleImage
   },
   methods: {
      register: async function() {
         try {
            this.$v.$touch();
            if(!this.$v.$invalid && confirm("Are you sure you want to save this record?")) {
               await axios.post(config.api.URL + '/api/games/add', this.gameForm, { params: { m: this.$route.meta.uid } });
               
               // alert("Game is added successfully.");
               // this.$router.push({path: '/games/list'});
            }
         } catch(error) {
            alert("Error!")
            console.log("error", error)
         }
      },
      addFeature: async function() {
         this.gameForm.feature.push('');
      },
      removeFeature: async function(index) {
         this.gameForm.feature.splice(index, 1);
      },
      uploadImageSuccess(formData, index, fileList) {
         this.gameForm.imagename = []
         this.gameForm.image = []
         fileList.forEach(element => {
            this.gameForm.imagename.push(element.name)
            this.gameForm.image.push(element.path)

            //  this.gameForm.image.push({
            //    name: this.element.name,
            //    path: element.path
            // })
         });
         console.log(this.gameForm.imagename)
      },
      beforeRemove (index, done, fileList) {
         console.log('index', index, fileList)
         var r = confirm("remove image")
         if (r == true) {
            done()
            this.gameForm.imagename = []
            this.gameForm.image = []
            fileList.forEach(element => {
               this.gameForm.imagename.push(element.name)
               this.gameForm.image.push(element.path)
            });
            console.log("after removed: "+this.gameForm.imagename)
         } 
         // else {
         // }
       },
      editImage (formData, index, fileList) {
         console.log('edit data', formData, index, fileList)
      },
      // onFileChange(event){
      //    this.gameForm.image = event.target.files[0];
      //    console.log("imagename: ", this.gameForm.image.name)
      //    this.gameForm.imagename = this.gameForm.image.name

      //    let reader  = new FileReader();
        
      //    let rawImg;
      //    reader.onloadend = () => {
      //       rawImg = reader.result;
      //       this.gameForm.image = rawImg
      //    }
         
      //    reader.addEventListener("load", function () {
      //       this.showPreview = true;
      //       this.imagePreview = reader.result;
      //    }.bind(this), false);

      //    if( this.gameForm.image ){
   
      //       if ( /\.(jpe?g|png|gif)$/i.test( this.gameForm.image.name ) ) {
      //          reader.readAsDataURL( this.gameForm.image);
      //       } else{
      //          alert("Invalid image format")
      //       }
      //    }
      // },
   }
}
</script>